import { describeFields, FieldWidget } from '../common/fields';
import { CLASS_DAY_OPTIONS } from './constants';
import { ClassSchema } from './schemas';

export const CLASS_FIELDS = describeFields(ClassSchema, {
  subject: { widget: FieldWidget.Text },
  classId: {},
  slackId: {},
  slackChannelName: {},
  course: { widget: FieldWidget.Select },
  stream: { widget: FieldWidget.Select },
  streams: { widget: FieldWidget.MultiSelect },
  day: { widget: FieldWidget.Select, options: CLASS_DAY_OPTIONS },
  time: { widget: FieldWidget.Time },
  teacher: { widget: FieldWidget.Autocomplete, displayField: 'teacherName' },
  marker: { widget: FieldWidget.Autocomplete, displayField: 'markerName' },
  tags: {},
  students: {},
  schoolTag: {},
  studentCount: { widget: FieldWidget.Text },
  studentCap: {},
  notes: {},
  active: { widget: FieldWidget.Text },
  waitlist: {},
  location: {},
  room: { widget: FieldWidget.Select, displayField: 'roomLabel' },
  remindBreaks: {},
  allowMakeups: {},
});
